import { useEffect, useState } from "react";
import { H3, Label } from "../Text";
import { toast } from "react-toastify";
import Circle from "../Animation/Circle";
import { Button } from "../Buttons";
import { Request } from "../../hooks/Request";
import TableComplete from "../Tables/TableComplete";
import { requestAuth } from "../services/RequestService";
import { useDialog } from "../../contexts/DialogContext";
import { validateArray } from "../../utils/validate";
import { DialogConfirmation } from "../Modal";

const InputSubDataCheckbox = ({ field, fullData, callForm, callSubData }) => {
  const { openDialog, dialogClose } = useDialog();

  const { data, loading, call } = Request({
    urlApi: `/dataSet/procedure/${field.id}/field/${field.fieldId}/subdata`,
  });

  const { data: document, loading: loadDocument } = Request({
    urlApi: field.urlApi,
  });

  let documentGroup = []
  if (field.urlApiGroup && field.urlApiGroup !== '') {
    const { data: dataDocumentGroup, loading: loadDocumentGroup } = Request({
      urlApi: field.urlApiGroup,
    });

    documentGroup = dataDocumentGroup;
  }


  useEffect(() => {
    call()
  }, [callSubData])


  function handleForm(item) {
    openDialog(
      <>
        {loadDocument && (
          <FormAddDocument
            data={document}
            item={item}
            reload={call}
            field={field}
            onClose={dialogClose}
          />
        )}
        <br />
      </>
    );
  }

  function handleMultiFill() {
    openDialog(
      <>
        {loadDocument && (
          <FormAddDocument
            data={documentGroup}
            // item={{ ...field, url: field.urlGroup }}
            reload={call}
            field={field}
            onClose={dialogClose}
            isMultiReg={true}
            fullData={fullData}
            itemData={{ ...field }}
            callForm={callForm}
            callSubData={callSubData}
          />
        )}
        <br />
      </>
    );
  }

  function handleDelete(data) {
    openDialog(
      <DialogConfirmation
        children={<H3>¿Estas seguro que quieres eliminar este item?</H3>}
        onClose={dialogClose}
        method="delete"
        url={`/dataSet/procedure/subData/${data.id}`}
        texBtn="Eliminar"
        handleSuccess={call}
      />
    );
  }
  if (!loading) {
    return <Circle />
  }
  if (field.countObs) {
    field.countObs(data.length)
  }

  return (
    <div className="bg-gray-300/40 p-1 rounded-md">
      <div className='flex items-start m-0 p-0 flex-row justify-between'>
        <Label htmlFor={field.name} className={`${field.className} my-0`}>
          {field.labelCustom ? field.labelCustom : field.label} {data.length > 0 ? <span className="text-[11px] bg-green-600 text-white rounded-md py-0.5 px-1" >Llenado</span> : <></>}
        </Label>
        {
          field.urlGroup && field.urlGroup !== "" &&
          <button
            className="flex items-center bg-yellow-500 p-1 rounded-md font-semibold text-sm"
            type="button"
            onClick={() => handleMultiFill()}
          >
            <i className="fa fa-circle-exclamation" />
          </button>
        }
      </div>
      {
        field.lockEdition ? (
          <div className=""></div>
        ) : (
          <div className="bg-gray-100 rounded-lg p-3 pt-2">
            {loadDocument && (
              <FormAddDocument
                data={document}
                dataList={data}
                reload={call}
                field={field}
                onClose={() => { }}
              />
            )}
          </div>
        )
      }
      <br />
      {
        !loading ? (
          <Circle />
        ) : (
          <div className="w-full">
            <TableComplete
              header={
                field.lockEdition
                  ? [
                    {
                      name: "label",
                      label: "Campo",
                    },
                    {
                      name: "description",
                      label: "Observación",
                    },
                  ]
                  : [
                    {
                      name: "label",
                      label: "Campo",
                    },
                    {
                      name: "description",
                      label: "Observación",
                    },
                    {
                      name: "creationDate",
                      label: "Fecha y hora",
                      type: "date"
                    },
                    {
                      name: "add",
                      type: "action",
                      label: "Opciones",
                      sticky: true,
                      actions: [
                        {
                          label: "Editar",
                          icon: "fas  fa-edit",
                          action: handleForm,
                          color: "text-[#1d4ed8]",
                        },
                        {
                          label: "Añadir",
                          icon: "fas fa-trash",
                          action: handleDelete,
                          color: "text-red-500",
                        },
                      ],
                    },
                  ]
              }
              data={data}
            />
          </div>
        )
      }
    </div >
  );
};

const FormAddDocument = ({ data, dataList = [], item = null, reload, field, onClose, fullData, itemData, callForm, callSubData }) => {
  const [values, setValues] = useState({
    Label: item?.label ? item.label : validateArray(data) ? data[0].name : "",
    NumberValue: item?.numberValue ? item.numberValue : 0,
    Description: item?.description ? item.description : "",
  });
  const [selectedValues, setSelectedValues] = useState([]);
  const fieldIds = fullData?.fields?.filter(f => f.urlGroup === itemData?.urlGroup)?.map(f => f.id).join('|') ?? null;


  async function handleSubmit() {
    const joinedString = selectedValues.join('|');
    await requestAuth(
      item ? "put" : "post",
      item
        ? `/dataSet/procedure/subData/${item.id}`
        : `/dataSet/procedure/${field.id}/field/${field.fieldId}/subdata${fieldIds ? `?fieldIds=${fieldIds}` : ''}`,
      { ...values, Label: joinedString }
    )
      .then(() => {
        reload();
        onClose();
        if (callForm) {
          callForm()
        }
        setValues({
          ...values,
          Label: joinedString,
          NumberValue: 0,
          Description: "",
        });
        toast.success("Registro exitoso");
      })
      .catch(() => {
        toast.error("Se produjo un error al guardar");
      });
  }

  function handleChangeInp(e) {
    const { name, value } = e.target;
    setValues((a) => ({
      ...a,
      [name]: value,
    }));
  }
  function handleChange(e) {
    setValues((a) => ({
      ...a,
      Label: e.value,
    }));
  }


  const handleCheckboxChange = (event) => {
    const { value, checked, name } = event.target;
    if (checked) {
      // Si está seleccionado, agregar a la lista
      setSelectedValues((prev) => [...prev, name]);
    } else {
      // Si está desmarcado, eliminar de la lista
      setSelectedValues((prev) => prev.filter((item) => item !== name));
    }
  };

  return (
    <form className="flex flex-col">
      {itemData &&
        <>
          <span>Campos afectados</span>
          {
            fullData?.fields?.filter(x => x.urlGroup === itemData?.urlGroup).map((f) => (
              <div>
                <span className="text-[#6189ca] font-bold">
                  {f.order}.
                </span>{" "}
                {f.label}
              </div>
            ))
          }
        </>
      }
      <Label className={`mt-2`}>Lista de campos</Label>
      {validateArray(data) ? (
        <>
          {/* <Select
            isSearchable={true}
            onChange={handleChange}
            styles={{
              placeholder: (base) => ({
                ...base,
                color: "black",
              }),
            }}
            // defaultInputValue={values[field.name]}
            placeholder={"Seleccionar..."}
            isOptionSelected={false}
            // isLoading={field.urlApi ? !loading : false}
            options={data.map((option) => ({
              value: option.name,
              label: option.name,
            }))}
          /> */}
          <div className='grid grid-cols-3 gap-x-3 gap-y-1'>
            {data.map((option, i) => (
              <div
                key={i}
                className={`flex items-center justify-between bg-gray-300 rounded-md p-1 gap-1`}
              >
                <div className="flex items-center gap-1">
                  <Label htmlFor={option.name}>{option.name}</Label>
                  {dataList.filter(a => a.label === option.name).length > 0 ? <i className="fa fa-check text-[10px] bg-blue-500 text-white rounded-full p-1" /> : <></>}
                </div>
                <span className="w-6 flex items-center">
                  <input
                    className={`cursor-pointer w-6 h-6 min:w-6`}
                    type="checkbox"
                    onChange={handleCheckboxChange}
                    name={option.name}
                  />
                </span>
              </div>
            ))}
          </div>
        </>
      ) : null}
      <Label className={`my-0 mt-4`}>Observación</Label>
      <div className="flex gap-2">
        <input
          value={values.Description}
          onChange={handleChangeInp}
          className="w-full p-2 rounded-md"
          type="text"
          name="Description"
        />
        <Button onClick={handleSubmit} className="px-3 py-0">
          Guardar
        </Button>
      </div>
    </form>
  );
};

export default InputSubDataCheckbox;
